export const toTrimmedLabel = (value) =>
  typeof value === "string" ? value.trim() : "";

export const resolveFolderRenameTargetLabel = (
  draftLabel,
  originalPersistedLabel,
) => {
  const trimmedDraft = toTrimmedLabel(draftLabel);
  if (trimmedDraft !== "") return trimmedDraft;
  return toTrimmedLabel(originalPersistedLabel);
};

export const isFolderRenameUnchanged = (draftLabel, originalDisplayLabel) =>
  toTrimmedLabel(draftLabel) === toTrimmedLabel(originalDisplayLabel);

export const getLowercaseBlockDocId = (blockId) =>
  String(blockId ?? "").trim().toLowerCase();

export const buildFolderRenameWritePlan = ({
  clientId,
  blocks,
  targetLabel,
}) => {
  if (!clientId || !Array.isArray(blocks)) return [];

  const safeLabel = toTrimmedLabel(targetLabel);
  const normalizedClientId = String(clientId);

  return blocks
    .map((block) => ({
      clientId: normalizedClientId,
      blockDocId: getLowercaseBlockDocId(block?.id),
      label: safeLabel,
    }))
    .filter((entry) => entry.blockDocId !== "");
};
